import { useQuery } from "@tanstack/react-query";
import { getReportTicketUsableCntToPrice } from "../../../../../service/report/ticket";
import { ColumnsType } from "antd/es/table";

const useGetReportTicketUsableCntToPrice = () => {
    const query = useQuery({
        queryKey: ['useGetReportTicketUsableCntToPrice'],
        queryFn: getReportTicketUsableCntToPrice,
        select: (res) => res.data
    });

    return query
}

const reportTicketUsableCntToPriceColumns: ColumnsType<IReportTicketUsableCntToPriceAdminResponse> = [
    {
        title: 'id',
        dataIndex: 'wellnessTicketId',
    },
    {
        title: '정기권명',
        dataIndex: 'wellnessTicketName',
        sorter: (a, b) => b.wellnessTicketName.localeCompare(a.wellnessTicketName),
    },
    {
        title: '기본가격',
        dataIndex: 'wellnessTicketPrice',
        render: q => q?.toLocaleString()
    },
    {
        title: '기본횟수',
        dataIndex: 'wellnessTicketTotalUsableCnt',
        render: q => q?.toLocaleString()
    },
    {
        title: '총잔여횟수',
        dataIndex: 'totalIssuedWellnessTicketSumRemainingCnt',
        render: q => q?.toLocaleString()
    },
    {
        title: '잔여 부채금액',
        render: (_, record) => {
            const { wellnessTicketPrice, wellnessTicketTotalUsableCnt, totalIssuedWellnessTicketSumRemainingCnt } = record;

            if (
                typeof wellnessTicketPrice === 'number' &&
                typeof wellnessTicketTotalUsableCnt === 'number' &&
                typeof totalIssuedWellnessTicketSumRemainingCnt === 'number' &&
                wellnessTicketTotalUsableCnt !== 0
            ) {
                const unitPrice = wellnessTicketPrice / wellnessTicketTotalUsableCnt;
                const result = unitPrice * totalIssuedWellnessTicketSumRemainingCnt;
                return Math.round(result).toLocaleString();
            }

            return '-';
        }
    }
]

const getTicketUsableCntToPriceCsvData = (
    data: IReportTicketUsableCntToPriceAdminResponse[]
) => {
    const csvData = data.map((record) => {
        const {
            wellnessTicketId,
            wellnessTicketName,
            wellnessTicketPrice,
            wellnessTicketTotalUsableCnt,
            totalIssuedWellnessTicketSumRemainingCnt,
        } = record;

        let 잔여부채금액 = '-';
        if (
            typeof wellnessTicketPrice === 'number' &&
            typeof wellnessTicketTotalUsableCnt === 'number' &&
            typeof totalIssuedWellnessTicketSumRemainingCnt === 'number' &&
            wellnessTicketTotalUsableCnt !== 0
        ) {
            const unitPrice = wellnessTicketPrice / wellnessTicketTotalUsableCnt;
            const result = unitPrice * totalIssuedWellnessTicketSumRemainingCnt;
            잔여부채금액 = Math.round(result).toLocaleString();
        }

        return {
            id: wellnessTicketId,
            정기권명: wellnessTicketName,
            기본가격: wellnessTicketPrice.toLocaleString(),
            기본횟수: wellnessTicketTotalUsableCnt.toLocaleString(),
            총잔여횟수: totalIssuedWellnessTicketSumRemainingCnt.toLocaleString(),
            잔여부채금액: 잔여부채금액,
        };
    });

    return csvData;
};


export { useGetReportTicketUsableCntToPrice, reportTicketUsableCntToPriceColumns, getTicketUsableCntToPriceCsvData }